import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, NavLink, Route, Switch, useHistory, withRouter} from 'react-router-dom';
import {PropTypes} from "prop-types";
import {bindActionCreators} from "redux";

import Loading from "../../../components/etc/loading";

import * as Actions from "../../../store/modules/journals";
import * as func from "../../../utils/functions";
import * as hooks from "../../../utils/hooks";

import {BASE_PATH} from "../../../wpconfig";
import MyPageContent from "../../../components/mypage/front";
import JournalContent from "../../../components/journal/front/detail/content";
import JournalSide from "../../../components/journal/front/detail/side";

class Mypage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			record : {}
		}

		this.onUpdate = this.onUpdate.bind(this);
	}

	componentDidMount() {
		hooks.menuHook(this);
		this.getDetail();
	}

	getDetail() {
		func.getData("my_library", null).then((response) => {
			if (!this.state.isInit) {
				this.setState({
					isInit: true,
				})
			}
			if(response.status) {
				this.setState({
					record : response.record
				})
			} else {
				alert(response.message);
				location.href = rmVars.loginUrl + encodeURIComponent(window.location.href);
			}
		});
	}

	onUpdate(record) {
		this.setState({record : record})
	}

	render() {
		return (
			<div className="contents-group">
				{!this.state.isInit ? <div className="m-auto m-0"><Loading/></div> :
					<MyPageContent record={this.state.record} onUpdate={this.onUpdate} />
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.journals.record ? state.journals.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Mypage)

Mypage.propTypes = {
	record: PropTypes.object,
	// records : PropTypes.array,
	// facet : PropTypes.object,
	// totalRecords : PropTypes.number,
	// totalPage : PropTypes.number,
};
